var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 50,
    viewBox: "0 0 122 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.828 23.6796C57.8729 23.6796 58.4563 23.304 58.4563 22.4997C58.4563 21.7483 57.8903 21.4207 56.828 21.4207H55.7613V23.6796H56.828ZM56.6627 20.4727C57.6551 20.4727 58.0774 20.0842 58.0774 19.4635C58.0774 18.773 57.6115 18.5107 56.6889 18.5107H55.7613V20.4727H56.6627ZM54.4987 17.5237H56.7759C58.2386 17.5237 59.3141 17.9737 59.3141 19.2846C59.3141 19.957 58.9484 20.6126 58.3258 20.8314V20.8749C59.1137 21.0537 59.6927 21.6043 59.6927 22.5698C59.6927 23.9989 58.5259 24.6669 56.9585 24.6669H54.4987V17.5237Z",
    fill: "#334A6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5608 17.5232H61.8234V24.6667H60.5608V17.5232Z",
    fill: "#334A6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7928 23.6401C66.2252 23.6401 67.0482 22.823 67.0482 21.0666C67.0482 19.3104 66.2252 18.5499 64.7928 18.5499H64.2401V23.6401H64.7928ZM62.9774 17.5232H64.8757C67.0571 17.5232 68.3457 18.7031 68.3457 21.0666C68.3457 23.4304 67.0571 24.6667 64.9411 24.6667H62.9774V17.5232Z",
    fill: "#334A6C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5234 18.5897H70.4684V17.5237H75.8411V18.5897H73.786V24.6672H72.5234V18.5897Z",
    fill: "#334A6C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5941 17.5232H77.8568V20.3939H80.7348V17.5232H81.9974V24.6667H80.7348V21.4992H77.8568V24.6667H76.5941V17.5232Z",
    fill: "#334A6C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.1573 17.5232H84.42V24.6667H83.1573V17.5232Z",
    fill: "#334A6C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0864 23.7518L85.8222 22.8825C86.3317 23.3693 87.0153 23.697 87.6768 23.697C88.478 23.697 88.918 23.3325 88.918 22.7753C88.918 22.1876 88.4584 21.9998 87.8121 21.7242L86.839 21.3004C86.138 21.008 85.4 20.4508 85.4 19.4067C85.4 18.2684 86.4012 17.3923 87.7903 17.3923C88.6218 17.3923 89.4272 17.7374 89.9847 18.3032L89.3358 19.1072C88.8832 18.7206 88.3997 18.4935 87.7903 18.4935C87.1155 18.4935 86.6756 18.8104 86.6756 19.3321C86.6756 19.8938 87.2176 20.1012 87.8077 20.3439L88.7676 20.7479C89.6146 21.1019 90.2066 21.6392 90.2066 22.6747C90.2066 23.8327 89.2489 24.7982 87.6509 24.7982C86.6885 24.7982 85.7615 24.4182 85.0864 23.7518Z",
    fill: "#334A6C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6798 31.8144C57.742 31.8144 58.2474 31.3906 58.2474 30.5127C58.2474 29.6256 57.6943 29.324 56.6362 29.324H55.7613V31.8144H56.6798ZM54.4987 28.3103H56.7408C58.3211 28.3103 59.4924 28.8609 59.4924 30.5127C59.4924 32.1052 58.3169 32.828 56.7844 32.828H55.7613V35.4542H54.4987V28.3103Z",
    fill: "#334A6C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9942 32.4775L65.6963 35.4539H64.2772L62.7451 32.6618L63.9942 32.4775ZM62.6659 31.6482C63.6413 31.6482 64.1726 31.2422 64.1726 30.4293C64.1726 29.6078 63.6413 29.324 62.6659 29.324H61.6602V31.6482H62.6659ZM60.3976 28.3103H62.7968C64.2772 28.3103 65.4178 28.8346 65.4178 30.4293C65.4178 31.5134 64.8494 32.1795 63.9942 32.4775C63.638 32.6016 63.2321 32.6618 62.7968 32.6618H62.7451H61.6602V35.4539H60.3976V28.3103Z",
    fill: "#334A6C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0125 31.8536C71.0125 30.25 70.29 29.2804 69.1711 29.2804C68.052 29.2804 67.3295 30.25 67.3295 31.8536C67.3295 33.4572 68.052 34.4838 69.1711 34.4838C70.29 34.4838 71.0125 33.4572 71.0125 31.8536ZM66.0317 31.8536C66.0317 29.5424 67.3162 28.1792 69.1711 28.1792C71.0258 28.1792 72.3099 29.5487 72.3099 31.8536C72.3099 34.1651 71.0258 35.585 69.1711 35.585C67.3162 35.585 66.0317 34.1651 66.0317 31.8536Z",
    fill: "#334A6C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2706 31.8144C76.3329 31.8144 76.8382 31.3906 76.8382 30.5127C76.8382 29.6256 76.2851 29.324 75.227 29.324H74.3521V31.8144H75.2706ZM73.0895 28.3103H75.3316C76.9119 28.3103 78.0832 28.8609 78.0832 30.5127C78.0832 32.1052 76.9078 32.828 75.3752 32.828H74.3521V35.4542H73.0895V28.3103Z",
    fill: "#334A6C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.9886 28.3103H83.2731V29.3763H80.2513V31.2073H82.8114V32.2733H80.2513V34.3878H83.3815V35.4539H78.9886V28.3103Z",
    fill: "#334A6C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.0056 32.4775L89.7076 35.4539H88.2885L86.7565 32.6618L88.0056 32.4775ZM86.6773 31.6482C87.6526 31.6482 88.1839 31.2422 88.1839 30.4293C88.1839 29.6078 87.6526 29.324 86.6773 29.324H85.6716V31.6482H86.6773ZM84.4089 28.3103H86.8081C88.2885 28.3103 89.4292 28.8346 89.4292 30.4293C89.4292 31.5134 88.8607 32.1795 88.0056 32.4775C87.6494 32.6016 87.2435 32.6618 86.8081 32.6618H86.7565H85.6716V35.4539H84.4089V28.3103Z",
    fill: "#334A6C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.68 29.3763H89.625V28.3103H94.9977V29.3763H92.9427V35.4539H91.68V29.3763Z",
    fill: "#334A6C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.3969 32.7975L95.255 28.3105H96.6046L97.3795 30.1368C97.5885 30.6677 97.7888 31.1638 98.0129 31.7074H98.0565C98.2809 31.1638 98.505 30.6677 98.7117 30.1368L99.4867 28.3105H100.802L98.6596 32.7975V35.4541H97.3969V32.7975Z",
    fill: "#334A6C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5033 40.712H42.9153C44.9419 40.712 46.5851 39.0634 46.5851 37.0294V16.3993C46.5851 15.1014 45.9043 13.8997 44.7933 13.2355L29.4588 4.0691C28.3017 3.37736 26.8599 3.37736 25.7028 4.0691L10.3686 13.2355C9.25738 13.8997 8.5769 15.1014 8.5769 16.3993V46.8644L16.4009 41.3761C17.0172 40.9438 17.7514 40.712 18.5033 40.712ZM29.0426 17.2403H26.1191V14.3061H29.0426V17.2403ZM20.2717 31.9102H17.3478V23.1082H20.2717V31.9102ZM17.3478 20.1744V17.2403H14.4243V34.844H23.1952V20.1744H17.3478ZM37.8139 31.9102H34.8901V23.1082H37.8139V31.9102ZM37.8139 17.2403V20.1744H31.9665V34.844H40.7374V17.2403H37.8139ZM26.1191 34.844H29.0426V20.1741H26.1191V34.844Z",
    fill: "#FF0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColor);
export default __webpack_public_path__ + "static/media/logo-color.644989f1ef595767be60effc3a9499f1.svg";
export { ForwardRef as ReactComponent };